import React from 'react'
import ReactS3Uploader from 'react-s3-uploader'
import Api from '../../middleware/api'


/* Vista*/
class S3Uploader extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      fileName: '',
    }
  }


  getSignedUrl = (file, callback) => {
    this.setState({fileName: `${this.props.id}_${file.name}`})
    Api.getS3Url(`${this.props.id}_${file.name}`).then((data) => {
      callback(data.data)
    }).catch((error) => {
      console.error(`Error:${error}`)
    })
  }
  click = () => {
    if (this.fileUpload.myUploader === undefined) {
      this.fileUpload.uploadFile()
    }
    this.fileUpload.myUploader.fileElement.click()
  }


  render() {
    return (
      <ReactS3Uploader
        ref={(input) => { this.fileUpload = input }}
        style={{ display: 'none' }}
        signingUrlMethod="POST"
        getSignedUrl={this.getSignedUrl}
        accept="image/*"
        signingUrlWithCredentials
        signingUrlHeaders={{ 'Access-Control-Allow-Origin': '*' }}
        preprocess={this.props.handlePreProcess}
        onProgress={this.props.handleProgress}
        onError={this.props.handleError}
        onFinish={(response) => { this.props.handleFinish(response, this.state.fileName) }}
        uploadRequestHeaders={{}}  // Don't send any headers, as the ACL is set via server
        contentDisposition="auto"
        scrubFilename={filename => filename.replace(/[^\w\d_\-.]+/ig, '')}
      />

    )
  }
}
S3Uploader.propTypes = {
  handleFinish: React.PropTypes.func.isRequired,
  handleError: React.PropTypes.func.isRequired,
  handleProgress: React.PropTypes.func.isRequired,
  id: React.PropTypes.number.isRequired,
}

/* Lógica*/

export default S3Uploader



// WEBPACK FOOTER //
// ./src/components/S3Uploader/index.jsx